module.exports = __webpack_public_path__ + "static/img/eyes_09.3e17722.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/eyes/thumbnail/eyes_09.png
// module id = gPUb
// module chunks = 0